import React from "react";
import PageLayout from "./PageLayout";
import WorkSection from "./WorkSection";
import usePageMeta from "../hooks/usePageMeta";

const WorkPage = () => {
  usePageMeta({
    title: "Trabajos realizados | RG Servicio Técnico",
    description:
      "Mirá trabajos recientes, resultados y detalles de reparación, mantenimiento y armado de equipos.",
    canonical: "https://rgserviciotecnico.com/trabajos"
  });

  return (
    <PageLayout className="bg-background">
      <WorkSection />
    </PageLayout>
  );
};

export default WorkPage;
